import { useQuery } from 'react-query';
import { apiClient, endpoints } from '../api/client';

export interface PerformanceMetrics {
  scraping: {
    requests_per_minute: number;
    average_response_time: number;
    success_rate: number;
    active_workers: number;
  };
  ai_validation: {
    validations_per_hour: number;
    corrections_applied: number;
    average_processing_time: number;
  };
  database: {
    queries_per_second: number;
    average_query_time: number;
    connection_pool_usage: number;
  };
  storage: {
    disk_usage: string;
    data_growth_rate: string;
    backup_status: string;
  };
}

export const usePerformanceMetrics = () => {
  return useQuery<PerformanceMetrics>(
    'performanceMetrics',
    async () => {
      const response = await apiClient.get(endpoints.systemStatus + '/performance');
      return response.data;
    },
    {
      refetchInterval: 5000, // Refetch every 5 seconds
      staleTime: 0, // Always consider data stale
      cacheTime: 0, // Don't cache data
    }
  );
};
